import ModulePlanningOverviewResourceModel from '../../generated/types/model/resource/ModulePlanningOverviewResourceModel';

export default class ModulePlanningOverviewResourceViewModel extends ModulePlanningOverviewResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
